import { EmailTypeMemberEnum, EmailType } from "../../Enums/EmailEnum";

export type EmailTypeKey = keyof typeof EmailTypeMemberEnum;

export const GDPR_KEY: EmailTypeKey = "dataPrivacy";

export const EMAIL_TYPE_ENTRIES = Object.entries(EmailTypeMemberEnum) as [
  EmailTypeKey,
  string,
][];

export const GDPR_FOOTNOTE =
  "Unsubscribing GDPR Data Privacy will stop all communications and invitations from WSG.";

/** Toggle ON = subscribed; categories in EmailUnsubscriber are unsubscribed. */
export function individualSubsFromUnsubscribed(
  unsubscribed: string[] | undefined,
): Record<EmailTypeKey, boolean> {
  const set = new Set((unsubscribed ?? []).map(String));
  const gdprOff = set.has(GDPR_KEY);

  return EMAIL_TYPE_ENTRIES.reduce(
    (acc, [key]) => {
      if (key === GDPR_KEY) {
        acc[key] = !gdprOff;
      } else if (gdprOff) {
        acc[key] = true;
      } else {
        acc[key] = !set.has(key);
      }
      return acc;
    },
    {} as Record<EmailTypeKey, boolean>,
  );
}

/** When GDPR is off, every row shows unsubscribed. */
export function displaySubsFromIndividual(
  individual: Record<EmailTypeKey, boolean>,
): Record<EmailTypeKey, boolean> {
  if (individual[GDPR_KEY]) {
    return individual;
  }

  return EMAIL_TYPE_ENTRIES.reduce(
    (acc, [key]) => {
      acc[key] = false;
      return acc;
    },
    {} as Record<EmailTypeKey, boolean>,
  );
}

/** Persisted list: GDPR off → only dataPrivacy; otherwise individual unsubscribes. */
export function unsubscribedToSave(
  individual: Record<EmailTypeKey, boolean>,
): EmailType[] {
  if (!individual[GDPR_KEY]) {
    return [GDPR_KEY];
  }
  return EMAIL_TYPE_ENTRIES.filter(([key]) => !individual[key]).map(
    ([key]) => key as EmailType,
  );
}

export function unsubscribedListsEqual(a: EmailType[], b: EmailType[]): boolean {
  if (a.length !== b.length) {
    return false;
  }
  const setA = new Set(a);
  return b.every((item) => setA.has(item));
}
